import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

/**
 * RoleGuard - Protects routes based on user role
 * 
 * Usage:
 * <RoleGuard allowedRoles={['admin']}>
 *   <AdminOnlyComponent />
 * </RoleGuard>
 * 
 * <RoleGuard allowedRoles={['admin', 'host']}>
 *   <AdminOrHostComponent />
 * </RoleGuard>
 */
const RoleGuard = ({ children, allowedRoles = [] }) => {
  const user = authService.getCurrentUser();
  
  // If no user, they shouldn't be here (ProtectedRoute should handle this)
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // Check if user's role is in the allowed roles list
  const hasAccess = allowedRoles.includes(user.role);
  
  if (!hasAccess) {
    return <Navigate to="/access-denied" />;
  }
  
  return children;
};

export default RoleGuard;
